import { Capacitor } from '@capacitor/core';
import Application from 'Application';
import AssetTransactionSlides from 'components/medium/asset-transaction/asset-transaction-slides-stack/AssetTransactionSlides';
import Modal from 'components/medium/modal/Modal';
import RightSection from 'components/medium/right-section/RightSection';
import SideMenu from 'components/medium/side-menu/SideMenu';
import SlidingPages from 'components/medium/sliding-pages/SlidingPages';
import AssetSlideUpView from 'components/small/asset-slide-up-view/AssetSlideUpView';
import BottomTabBar from 'components/small/bottom-tab-bar/BottomTabBar';
import Footer from 'components/small/footer/Footer';
import InternalCookieConsent from 'components/small/internal-cookie-consent/InternalCookieConsent';
import ResumeOnboardingButton from 'components/small/resume-onboarding-button/ResumeOnboardingButton';
import ThemeProviderWrapper from 'components/small/theme-provider/ThemeProvider';
import TopBar from 'components/small/top-bar/TopBar';
import { LOCAL_STORAGE_KNOWN_KEYS, TRENDEX_ROLES, onboardingEndpoints } from 'config/_const';
import { AssetTransactionType, BitPayInitiationPages, RedirectInitiationPage, URL_INTENT } from 'config/_enums';
import { MENU_ITEMS } from 'config/menu';
import MenuInterface from 'model/Menu/MenuInterface';
import Top50SkeletonLoading from 'page/Top50/top50SkeletonLoading/Top50SkeletonLoading';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, BrowserRouter as Router } from 'react-router-dom';
import { compose } from 'redux';
import AppRouter from 'router/app.router';
import { actionFetchAssetCategory } from 'service/asset-category/actions';
import { openAssetTransactionSlides } from 'service/asset-transaction-slideup/action';
import { selectorAccountViewModel } from 'service/auth/selectors';
import { managementModal } from 'service/modal/action';
import { managementSideMenu } from 'service/side-menu/action';
import { openSlidingPage } from 'service/sliding-pages/action';
import 'service/whatsapp/WhatsAppButton.scss';
import whatsappService from 'service/whatsapp/WhatsAppService';
import Utils from 'utils/Utils';
import '../../../src/assets/css/bootstrap.min.css';
import AppContainerProps from './AppContainerProps';
import AppContainerState from './AppContainerState';

const WalletRefund = React.lazy(() => import("components/medium/wallet-refund/WalletRefund"));

class AppContainer extends React.Component<AppContainerProps, AppContainerState> {
    private sideMenuDivRef: React.RefObject<HTMLDivElement>;

    constructor(props: AppContainerProps) {
        super(props);
        this.state = {
            activeItem: MENU_ITEMS[0],
        };
        this.sideMenuDivRef = React.createRef();
    }

    componentWillMount = async () => {
        localStorage.setItem(LOCAL_STORAGE_KNOWN_KEYS.TDX_THEME, 'light');
        const enableDarkTheme: boolean = localStorage.getItem(LOCAL_STORAGE_KNOWN_KEYS.TDX_THEME) === 'dark';
        this.activeLightTheme(enableDarkTheme);
        this.props.actionFetchAssetCategory();
    };

    async componentDidMount(): Promise<void> {
        this.switchPageStateFromUrlParams();
        // this.showNewPlatformAnnouncementIfNeeded();
        whatsappService.init();
    }

    showNewPlatformAnnouncementIfNeeded = () => {
        const hasSeenAnnouncement = localStorage.getItem(LOCAL_STORAGE_KNOWN_KEYS.NEW_PLATFORM_ANNOUNCEMENT_SEEN);
        const isDisabled = false;
        if (hasSeenAnnouncement || isDisabled) {
            return;
        }

        // setTimeout(() => {
        //     this.props.managementModal(true, {
        //         display: true,
        //         disableBackDrop: false,
        //         showBackArrow: false,
        //         fullScreen: false,
        //         showCancelButton: false,
        //         type: 'CONFIRMATION_MODAL',
        //         propsCustom: {
        //             message: (
        //                 <div style={{
        //                     textAlign: 'center',
        //                     maxWidth: '100%'
        //                 }}>
        //                     <div style={{
        //                         display: 'flex',
        //                         alignItems: 'center',
        //                         justifyContent: 'center',
        //                         marginBottom: '20px',
        //                         gap: '8px'
        //                     }}>
        //                         <h2 style={{
        //                             margin: 0,
        //                             fontSize: window.innerWidth <= 480 ? '18px' : '22px',
        //                             lineHeight: '1.2',
        //                             fontWeight: 'bold',
        //                             color: '#333'
        //                         }}>
        //                             {i18next.t('newPlatform.announcement.title')}
        //                         </h2>
        //                     </div>

        //                     <div style={{
        //                         backgroundColor: '#f8f9fa',
        //                         borderRadius: '12px',
        //                         padding: '20px',
        //                         marginBottom: '20px',
        //                         border: '1px solid #e9ecef'
        //                     }}>
        //                         <p style={{
        //                             margin: '0 0 16px 0',
        //                             lineHeight: '1.6',
        //                             fontSize: window.innerWidth <= 480 ? '14px' : '16px',
        //                             color: '#495057',
        //                             textAlign: 'left'
        //                         }}>
        //                             {i18next.t('newPlatform.announcement.content')}
        //                         </p>
        //                     </div>
        //                 </div>
        //             ),
        //             acceptBtnText: i18next.t('newPlatform.announcement.cta'),
        //             cancelBtnText: i18next.t('newPlatform.announcement.stay'),
        //             hideCancelBtn: false,
        //             fullButtons: false,
        //             onValidation: () => {
        //                 localStorage.setItem(LOCAL_STORAGE_KNOWN_KEYS.NEW_PLATFORM_ANNOUNCEMENT_SEEN, 'true');
        //                 window.location.replace('https://app.trendex.gg/');
        //                 this.props.managementModal(false);
        //             },
        //             onRefused: () => {
        //                 localStorage.setItem(LOCAL_STORAGE_KNOWN_KEYS.NEW_PLATFORM_ANNOUNCEMENT_SEEN, 'true');
        //                 this.props.managementModal(false);
        //             },
        //         },
        //     });
        // }, 1500);
    };

    switchPageStateFromUrlParams(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectTo = urlParams.get(URL_INTENT.REDIRECT_TO);

        switch (redirectTo) {
            case BitPayInitiationPages.REFUND_WALLET:
                this.props.openSlidingPage(<WalletRefund />);
                break;
            case BitPayInitiationPages.BUY_ASSET:
                const currentTransactionId = localStorage.getItem(LOCAL_STORAGE_KNOWN_KEYS.CURRENT_TRANSACTION_ASSET_ID);
                currentTransactionId && this.props.openAssetTransactionSlides(currentTransactionId, AssetTransactionType.BUY);
                break;
            case RedirectInitiationPage.BUY_ASSET:
                const assetId = urlParams.get("assetId");
                assetId && this.props.openAssetTransactionSlides(assetId, AssetTransactionType.BUY);
        }
    }


    addSideMenuActiveClassMenu = () => {
        document.getElementById('sidemenusec')?.classList.add('active');
        document.getElementById('close_back')?.classList.add('active');
    };

    removeSideMenuActiveClass = () => {
        document.getElementById('sidemenusec')?.classList.remove('active');
        document.getElementById('close_back')?.classList.remove('active');
    };

    onMenuItemsSelected = (item: MenuInterface) => {
        if (Utils.isMobile()) {
            this.props.managementSideMenu();
        }

        this.setState({
            activeItem: item,
        });
    };

    activeLightTheme = (state: boolean) => {
        return !state ? document.getElementById('mainbody')?.classList.add('light_demo') : document.getElementById('mainbody')?.classList.remove('light_demo');
    };

    render = () => {
        const {
            sideMenu,
            auth,
            appConfig: { data: { device } } } = this.props;
        const isIOS = device?.platform === 'ios';

        if (auth.IsDisabled && !auth.IsAdminToVip) {
            document.write('<div style="background-color:blue;width:100vw;height:100vh;"></div>');
            return <></>;
        }

        const onboardingMode: boolean = auth.IsOnboardingRunning && Application.getInstance().OnBoardingV2;
        const redirectTo = onboardingMode ? onboardingEndpoints[auth.OnboardingStep] : window.location.pathname;
        const resumeOnboarding: boolean = onboardingMode;

        return (
            <Router>
                {isIOS && <div className="app-navbar-notch" />}
                <AssetSlideUpView />
                <Modal />
                <ThemeProviderWrapper>
                    <div className={'main-app' + (this.props.auth.UserType === TRENDEX_ROLES.ADMIN ? ' admin-mode' : '')} onClick={() => sideMenu.data.display && Utils.isMobile() ? this.props.managementSideMenu() : undefined}>
                        <div className="mainframe_section">
                            <div ref={this.sideMenuDivRef} id="sidemenusec" className="sidemenu_section">
                                <SideMenu
                                    sideMenuDivRef={this.sideMenuDivRef}
                                    removeActiveClass={this.removeSideMenuActiveClass}
                                    onItemSelected={this.onMenuItemsSelected}
                                    items={MENU_ITEMS} />
                            </div>

                            {!onboardingMode && <BottomTabBar
                                isAdminToVip={auth.IsAdminToVip}
                                isAuthenticated={auth.isAuthenticated}
                                accountType={auth.UserType} />
                            }

                            <div className="header_section">
                                <TopBar addSideMenuActiveClassMenu={this.addSideMenuActiveClassMenu} />
                            </div>

                            {resumeOnboarding &&
                                <ResumeOnboardingButton auth={auth} />
                            }

                            <React.Suspense fallback={<Top50SkeletonLoading />}>
                                <div className="main_section">
                                    <div className="router contact_pages_e">

                                        <AppRouter />
                                        {onboardingMode && <Redirect to={redirectTo} />}
                                    </div>
                                    {!Capacitor.isNativePlatform() && !Application.getInstance().IsInjectedAsIframe && !onboardingMode && <InternalCookieConsent />}
                                    {!(Application.getInstance().OnBoardingV2 && auth.IsOnboardingRunning) &&
                                        <div className="footer_sec">
                                            <Footer />
                                        </div>
                                    }
                                    <AssetTransactionSlides />
                                    <SlidingPages
                                    />
                                </div>

                                <div id="close_back" className="close_background" onClick={() => this.removeSideMenuActiveClass()} ></div>

                            </React.Suspense>

                            <RightSection />

                        </div>
                    </div>
                </ThemeProviderWrapper>
            </Router>

        );
    };
}

const mapStateToProps = (state: AppContainerProps) => ({
    auth: selectorAccountViewModel(state),
    sideMenu: state.sideMenu,
    appConfig: state.appConfig,
});

export default compose(
    connect(mapStateToProps, {
        managementSideMenu,
        managementModal,
        actionFetchAssetCategory,
        openSlidingPage,
        openAssetTransactionSlides
    }),
)(AppContainer);
